import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import Vuex from 'vuex'
import store from './store'
import dayjs from 'dayjs'
import zhtw from 'dayjs/locale/zh-tw'
import '@/assets/knst-ci/style.css'
import 'firebase/app'
import 'firebase/messaging'
import { getAuth, onAuthStateChanged, signInWithCustomToken } from 'firebase/auth'
import { getStorage, ref, uploadBytes, uploadString } from 'firebase/storage'
import 'firebase/database'
// ElementUI
import ElementUI from 'element-ui'
/* import 'element-ui/lib/theme-chalk/index.css'; */
import '@/assets/sass/element-variables.scss'
import locale from 'element-ui/lib/locale/lang/zh-TW'
// print
import Print from '@/js/utils/print'
import VueQr from 'vue-qr'
import Lightbox from '../static/vue-my-photos'
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import iframeResize from 'iframe-resizer/js/iframeResizer'
import horizontalScroll from 'el-table-horizontal-scroll'
import * as Sentry from '@sentry/vue'
import Infobip from '@/js/utils/infobip'
// ! Start 飯糰、沐謙討論後表示不要再增加進全域了，需要時再各自 import 即可 -------------------------------------------------
import { apiAttendanceManagement } from '@/api/AttendanceManagement'
import { apiBulletin } from '@/api/Bulletin'
import { apiBaAlert } from '@/api/baAlert'
import { apiBaAlertSource } from '@/api/baAlertSource'
import { apiBillservice } from '@/api/billService'
import { apiBillserviceKGI } from '@/api/billServiceKGI'
import { apiCalendar } from '@/api/Calendar'
import { apiGas } from '@/api/Gas'
import { apiMessage } from '@/api/Message'
import { apiSystem } from '@/api/SystemUpdates'
import { apiGuest } from '@/api/Guest'
import { apiUnitOwnerAssembly } from '@/api/UnitOwnerAssembly'
import { apiIntercom } from '@/api/Intercom'
import { apiVote } from '@/api/Vote'
import { apiManagement } from '@/api/Management'
import { apiAsset } from '@/api/smartBuildingSystemAPI'
import { apiHousehold } from './api/houseHold'
import i18n from '@/lang/i18n'
import VueGtag from 'vue-gtag'
import { thousandthInput } from '@/directives/thousandthInput'
import { CommunityMainServiceType } from '@/js/utils/communityMainService.js'
import BottomRightToastPlugin from '@/js/utils/bottomRightToast.js'


// 將現有的 localStorage 存入 store
const currentLocalStorage = {}
Object.entries(localStorage).forEach(([key, value]) => {
  try {
    currentLocalStorage[key] = JSON.parse(value)
  } catch (error) {
    currentLocalStorage[key] = value
  }
})
store.commit('setLocalStorage', currentLocalStorage)
// 後續新增的 localStorage 也都存入 store 中
const originalSetItem = localStorage.setItem
localStorage.setItem = function (key, value) {
  originalSetItem.call(this, key, value)
  try {
    const newLocalStorage = {
      ...store.state.localStorage,
      [key]: JSON.parse(value)
    }
    store.commit('setLocalStorage', newLocalStorage)
  } catch (error) {
    console.error('Error parsing localStorage data:', error)
  }
}

Vue.directive('resize', {
  bind: function (el, { value = {} }) {
    el.addEventListener('load', () => iframeResize(value, el))
  },
  unbind: function (el) {
    el.iFrameResizer.removeListeners()
  }
})

thousandthInput(Vue)

Vue.use(Print)
Vue.use(VueQr)
Vue.use(Vuex)
Vue.use(ElementUI, { locale })
Vue.use(CoolLightBox)
Vue.use(horizontalScroll)
Vue.use(VueGtag, {
  config: {
    id: process.env.NODE_ENV === 'development' ? 'G-Q2M0PKND23' : 'G-ZB76RKYHFN',
    params: {
      appName: 'MGMT'
    }
  }
})
Vue.component('Lightbox', Lightbox)
Vue.use(Infobip)
Vue.use(BottomRightToastPlugin)
// ----------------------------------------------------------------------------------------------------
global.firebaseConfig = {
  apiKey: 'AIzaSyBFpc6MJsvPG76ruHst31bTw1kH8fAQx1c',
  authDomain: 'kingnetcare.firebaseapp.com',
  databaseURL: 'https://kingnetcare.firebaseio.com',
  projectId: 'kingnetcare',
  storageBucket: 'kingnetcare',
  messagingSenderId: '865338099412',
  appId: '1:865338099412:web:1b0fc30cb1b695495edd41',
  measurementId: 'G-5QLP4J7VX6'
}
global.kingetcareFb = null
global.fbMessaging = null
global.axios = axios
global.vuecp = {}
global._cloneDeep = require('lodash/cloneDeep')
global._isEqual = require('lodash/isEqual')
global._isEmpty = require('lodash/isEmpty')
global.vue = Vue
global.dayjs = dayjs
dayjs.locale({
  ...zhtw,
  weekStart: 1
})
// * 更改header要跳轉上一頁的路徑，改為帶參數路徑
// 1. 請在路徑 meta.prev 輸入'other'
// 2. 在組建內手動輸入上一頁路徑
global.previousPage = { name: 'home' }

Vue.prototype.$tempHiddenShow = false
Vue.prototype.$formatDate = (date) => { // 生成字串符2019/01/22
  if (date) {
    const fullDate = new Date(date)
    // 年
    let y = fullDate.getFullYear()
    for (let len = (y + '').length; len < 4; len = y.length) {
      y = '0' + y
    }
    // 月
    let m = fullDate.getMonth() + 1
    if (m < 10) m = '0' + m
    // 日
    let d = fullDate.getDate()
    if (d < 10) d = '0' + d
    return y + '/' + m + '/' + d
  } else {
    return ''
  }
}
Vue.prototype.$newFormatDate = (date, format = 'yyyy-MM-dd HH:mm:ss') => { // 生成字串符2019-01-22 12:01:01
  if (date) {
    const fullDate = new Date(date)
    const year = fullDate.getFullYear()
    const month = (fullDate.getMonth() + 1).toString().padStart(2, '0')
    const day = fullDate.getDate().toString().padStart(2, '0')
    const hour = fullDate.getHours().toString().padStart(2, '0')
    const min = fullDate.getMinutes().toString().padStart(2, '0')
    const sec = fullDate.getSeconds().toString().padStart(2, '0')
    return format.replace('yyyy', year).replace('MM', month).replace('dd', day).replace('HH', hour).replace('mm', min).replace('ss', sec)
  } else {
    return ''
  }
}
Vue.prototype.$dayDiff = (startDay, endDay) => { // 計算時間差，輸出間隔天數
  const startDate = new Date(startDay)
  const endDate = new Date(endDay)
  const diffDays = parseInt(Math.abs(startDate - endDate) / 1000 / 60 / 60 / 24)
  return diffDays
}
Vue.prototype.$timeSince = (date) => { // 計算與當下時間差，輸出對應描述
  const differTime = new Date().getTime() - new Date(date).getTime()
  const msPerMin = 60 * 1000
  const msPerHour = 60 * msPerMin
  const msPerDay = 24 * msPerHour
  const msPerWeek = 7 * msPerDay
  const msPerMonth = 30 * msPerDay
  const msPerYear = 365 * msPerDay
  let value = 0
  value = Math.floor(differTime / msPerYear)
  if (value > 0) return `${value}年前`
  value = Math.floor(differTime / msPerMonth)
  if (value > 0) return `${value}個月前`
  value = Math.floor(differTime / msPerWeek)
  if (value > 0) return `${value}週前`
  value = Math.floor(differTime / msPerDay)
  if (value > 0) return `${value}天前`
  value = Math.floor(differTime / msPerHour)
  if (value > 0) return `${value}小時前`
  value = Math.floor(differTime / msPerMin)
  if (value > 0) return `${value}分鐘前`
  return '現在'
}
Vue.prototype.$toMainPage = () => {
  if (process.env.NODE_ENV === 'development') {
    router.push({ name: 'home' })
  } else {
    window.location.href = `${window.location.origin}/community/main.aspx`
  }
}
Vue.prototype.$toPage = (page) => {
  window.location.href = `${window.location.origin}/community/${page}.aspx`
}
Vue.prototype.$isServiceEnabled = (serviceId) => {
  return !!store.state.localStorage.communityMainService?.find(el => el.CommunityMainServiceType === CommunityMainServiceType.Plugin && el.Id === serviceId)
}
// 開啟外部連結，多用於：新版介紹、滿意度調查
Vue.prototype.$toExternaLink = (url) => {
  window.open(url, '_blank')
}
Vue.prototype.$logoutCommunity = () => {
  const loading = Vue.prototype.$loading()
  const removeKeys = ['isFloatIconClose', 'isMarqueeClose']
  removeKeys.forEach(key => { sessionStorage.removeItem(key) })
  const url = process.env.NODE_ENV === 'development' ? '/localmvc/ServiceWorker/AuthorizationLogout' : `${process.env.VUE_APP_MVC_URL}/ServiceWorker/AuthorizationLogout`
  axios(url, {
    method: 'GET'
  }).then((res) => {
    // 清空指定名稱的 cookie
    function clearCookie (cookieName) {
      document.cookie = cookieName + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/'
    }
    clearCookie('comLoginToken')
    loading.close()
    if (!(window.location.href.indexOf('login') > -1)) {
      localStorage.setItem('loginStatus', false)
      router.push({ name: 'LoginMain' })
    }
    Vue.prototype.$infobipForgetUser()
  }).catch((err) => {
    loading.close()
    console.log(err)
    console.log(err.response)
  })
}
Vue.prototype.$checkPermission = () => { // default granted denied
  console.log('checkPermission')
  if ('Notification' in window) {
    Notification.requestPermission((permission) => {
      return permission
    })
  }
}
Vue.prototype.$getCookie = (name) => {
  const value = '; ' + document.cookie
  const parts = value.split('; ' + name + '=')
  // eslint-disable-next-line eqeqeq
  if (parts.length == 2) { return parts.pop().split(';').shift() }
}
Vue.prototype.$base64Decode = (encoded, callback) => {
  let result = {
    isBase64: false,
    base64: null,
    mineType: null,
    fileExtension: null
  }
  if (typeof encoded !== 'string') {
    return result
  }
  const mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/)
  // eslint-disable-next-line eqeqeq
  if (mime && mime.length == 2) {
    result = {
      isBase64: true,
      base64: encoded.split(',')[1],
      mineType: mime[1],
      fileExtension: mime[1].split('/')[1]
    }
  }
  callback(result)
}
Vue.prototype.$uploadFileToFirebase = (Option, callback) => {
  let comId = ''
  const option = {
    file: Option.file,
    folder: Option.folder,
    // eslint-disable-next-line eqeqeq
    fileName: Option.fileName != undefined ? Option.fileName : null
  }
  const auth = getAuth(kingetcareFb)
  onAuthStateChanged(auth, (user) => {
    if (user != null) {
      comId = user.uid
      if (option.file.isBase64) {
        upload_bs64()
      } else {
        upload_bolb()
      }
    } else {
      login()
    }
  })
  function login () {
    const url = process.env.NODE_ENV === 'development' ? '/house/getUserUID' : `${process.env.VUE_APP_WS_URL}/getUserUID`
    const data = new FormData()
    data.append('Database', 'Kingnetcare')
    axios(url, {
      method: 'POST',
      data
    }).then(async (res) => {
      const auth = getAuth(kingetcareFb)
      try {
        await signInWithCustomToken(auth, res.data.token)
      } catch (err) {
        console.log(err)
        callback('error')
      }
    }).catch(err => {
      callback('error')
    })
  }
  // 上傳動作(Bolb)
  async function upload_bolb () {
    const getDate = new Date()
    const url = `web/CHK/${comId}/${option.folder}/${getDate.getFullYear()}/${('0' + (getDate.getMonth() + 1)).slice(-2)}/${('0' + getDate.getDate()).slice(-2)}/`
    const fileName = option.fileName == null ? (getDate.getFullYear()) + ('0' + (getDate.getMonth() + 1)).slice(-2) + ('0' + getDate.getDate()).slice(-2) + getDate.getHours() + ('0' + getDate.getMinutes()).slice(-2) + ('0' + getDate.getSeconds()).slice(-2) + getDate.getMilliseconds() : option.fileName
    const DeputyFileName = option.file.fileExtension

    const storage = getStorage(kingetcareFb)
    const reference = ref(storage, url + fileName + '.' + DeputyFileName)
    const metadata = {
      contentType: option.file.mineType
    }
    try {
      await uploadBytes(reference, option.file, metadata)
      callback('https://file.kingnetsmart.com.tw/' + url + fileName + '.' + DeputyFileName)
    } catch (err) {
      console.log(err)
      callback('error')
    }
  }
  // 上傳動作(base64)
  async function upload_bs64 () {
    const getDate = new Date()
    const url = `web/CHK/${comId}/${option.folder}/${getDate.getFullYear()}/${('0' + (getDate.getMonth() + 1)).slice(-2)}/${('0' + getDate.getDate()).slice(-2)}/`
    const fileName = option.fileName == null ? (getDate.getFullYear()) + ('0' + (getDate.getMonth() + 1)).slice(-2) + ('0' + getDate.getDate()).slice(-2) + getDate.getHours() + ('0' + getDate.getMinutes()).slice(-2) + ('0' + getDate.getSeconds()).slice(-2) + getDate.getMilliseconds() : option.fileName
    const DeputyFileName = option.file.fileExtension

    const storage = getStorage(kingetcareFb)
    const reference = ref(storage, url + fileName + '.' + DeputyFileName)
    const metadata = {
      contentType: option.file.mineType
    }
    try {
      await uploadString(reference, option.file.base64, 'base64', metadata)
      callback('https://file.kingnetsmart.com.tw/' + url + fileName + '.' + DeputyFileName)
    } catch (err) {
      console.log(err)
      callback('error')
    }
  }
}
// 首頁獲取資料方法
Vue.prototype.$getAPI = (url, mode = 'GET', postData = null) => {
  console.log(postData)
  let header
  if (mode === 'GET') {
    header = {
      method: mode,
      params: postData,
      headers: {
        KingnetAuth: `Cookies ${Vue.prototype.$getCookie('comLoginToken').replace('token=', '')}`
      }
    }
  } else {
    header = {
      method: mode,
      data: postData,
      headers: {
        KingnetAuth: `Cookies ${Vue.prototype.$getCookie('comLoginToken').replace('token=', '')}`
      }
    }
  }

  return axios(
    url,
    header
  ).then(res => {
    return res.data.Data
  }).catch(err => {
    throw err
  })
}
// TODO: 之後要整合 jwt 流程（含 x-requestid）
// 取得JWTToken，目前用於訪客登記結合門禁系統
Vue.prototype.$getJWTToken = () => {
  return new Promise((resolve, reject) => {
    // 這兩個根本一樣，無需再經由 keeper 這個 proxy
    const url = `${process.env.VUE_APP_HOUSEKEEPER_URL}/api/v1/Identity/Login/Admin/WebCookie`
    const webcookie = Vue.prototype.$getCookie('comLoginToken').split('token=').pop()
    axios(url, {
      method: 'POST',
      headers: {
        webcookie,
        'x-requestid': Vue.prototype.$getGuid()
      }
    }).then(res => {
      resolve(res)
      document.cookie = 'JwtToken=Bearer ' + res.data.AccessToken + `; path=${process.env.NODE_ENV === 'development' ? '/' : '/mgmt'}`
      document.cookie = 'refreshToken= ' + res.data.RefreshToken + `; path=${process.env.NODE_ENV === 'development' ? '/' : '/mgmt'}`
      // 確認目前的 jwtToken，之後整合會拔掉
      const jwtToken = Vue.prototype.$getCookie('JwtToken').replace('Bearer ', '')
      const refreshToken = Vue.prototype.$getCookie('refreshToken').replace('JwtToken=Bearer ', '')
      console.log('jwt', { 'x-requestid': Vue.prototype.$getGuid(), jwtToken, refreshToken })
    }).catch(err => {
      resolve(err.response)
    })
  })
}
// TODO: 目前都報 400 Error
// 後端現階段不做，我們下階段再來
Vue.prototype.$refreshJWTToken = () => {
  return new Promise((resolve, reject) => {
    const url = `${process.env.VUE_APP_HOUSEKEEPER_URL}/api/v1/Identity/RefreshJwtToken`
    const jwtToken = Vue.prototype.$getCookie('JwtToken').replace('Bearer ', '')
    const refreshToken = Vue.prototype.$getCookie('refreshToken').replace('JwtToken=Bearer ', '')
    console.log('jwtToken', jwtToken, 'refreshToken', refreshToken)
    axios(url, {
      method: 'POST',
      headers: {
        'x-requestid': Vue.prototype.$getGuid()
      },
      data: {
        jwtToken,
        refreshToken
      }
    }).then(res => {
      console.log('RefreshJwtToken', res)
      resolve(res)
      document.cookie = 'JwtToken' + '=' + 'Bearer ' + res.data.AccessToken + `; path=${process.env.NODE_ENV === 'development' ? '/' : '/mgmt'}`
    }).catch(err => {
      resolve(err.response)
    })
  })
}
Vue.prototype.$getGuid = () => {
  let d = Date.now()
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now() // use high-precision timer if available
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
  })
}

const promptWithGapHeight = 45.5
// this function will work cross-browser for loading scripts asynchronously
Vue.prototype.$loadScript = (src) => {
  return new Promise(function (resolve, reject) {
    const s = document.createElement('script')
    s.src = src
    s.onload = resolve
    s.onerror = reject
    document.head.appendChild(s)
  })
}
Vue.prototype.$downloadFile = (data, fileName) => {
  const url = window.URL.createObjectURL(new Blob([data]))
  const el = document.createElement('a')
  el.href = url
  el.setAttribute('download', fileName)
  document.body.appendChild(el)
  el.click()
  document.body.removeChild(el)
  window.URL.revokeObjectURL(url)
}
Vue.prototype.$handleScroll = async (callback, loadingHeight = promptWithGapHeight) => {
  const scrollTop = document.documentElement.scrollTop
  const clientHeight = document.documentElement.clientHeight
  const scrollHeight = document.documentElement.scrollHeight
  const endTop = scrollHeight - clientHeight
  if (scrollTop >= endTop - 20) {
    try {
      // 有回傳 true 才會 scrollTo 原始高度
      // 有回傳 false 才會 scrollTo 原始高度 - 10 避免一直發送請求
      // 目前回傳 undefined 就是正在打這支 API
      const success = await callback()
      if (success) {
        window.scrollTo({
          // 這樣寫是因為 loadingHeight 可能在 callback 執行時才會長出來
          top: endTop + loadingHeight
        })
      } else if (success === false) {
        Vue.prototype.$message({
          message: i18n.t('Server.TryAgainLater'),
          type: 'warning'
        })
        window.scrollTo({
          top: endTop - 10
        })
      }
    } catch (error) {
      console.log(error)
    }
  }
}
Vue.prototype.$scrollLoading = false
Vue.prototype.$handleScrollWithLoading = async (callback, loadingHeight = promptWithGapHeight) => {
  if (Vue.prototype.$scrollLoading) return
  const scrollTop = document.documentElement.scrollTop
  const clientHeight = document.documentElement.clientHeight
  const scrollHeight = document.documentElement.scrollHeight
  const endTop = scrollHeight - clientHeight
  if (scrollTop >= endTop - 20) {
    Vue.prototype.$scrollLoading = true
    try {
      // 有回傳 true 才會 scrollTo 原始高度
      // 有回傳 false 才會 scrollTo 原始高度 - 10 避免一直發送請求
      // 目前回傳 undefined 就是正在打這支 API
      const success = await callback()
      if (success) {
        window.scrollTo({
          // 這樣寫是因為 loadingHeight 可能在 callback 執行時才會長出來
          top: endTop + loadingHeight
        })
      } else if (success === false) {
        Vue.prototype.$message({
          message: i18n.t('Server.TryAgainLater'),
          type: 'warning'
        })
        window.scrollTo({
          top: endTop - 10
        })
      }
    } catch (error) {
      console.log(error)
    } finally {
      Vue.prototype.$scrollLoading = false
    }
  }
}
Vue.prototype.$sleep = (totalMs = 2 * 1000, alreadyMs = 0) => {
  if (alreadyMs >= totalMs) return
  return new Promise(resolve => setTimeout(resolve, totalMs - alreadyMs))
}

Vue.prototype.$versionCompare = (ver1, ver2) => {
  // 版本比較 1為大於 0 為等於 -1 為小於
  const version1 = ver1.split('.')
  const version2 = ver2.split('.')
  const maxL = Math.max(version1.length, version2.length)

  let result = 0

  for (let i = 0; i < maxL; i += 1) {
    const compareValue1 = version1.length > i ? version1[i] : 0
    const compareNum1 = Number.isNaN(Number(compareValue1))
      ? compareValue1.charCodeAt(0)
      : Number(compareValue1)
    const compareValue2 = version2.length > i ? version2[i] : 0
    const compareNum2 = Number.isNaN(Number(compareValue2))
      ? compareValue2.charCodeAt(0)
      : Number(compareValue2)

    if (compareNum1 > compareNum2) {
      result = 1
      break
    } else if (compareNum1 < compareNum2) {
      result = -1
      break
    }
  }
  return result
}
Vue.prototype.$openNewPageToPath = (path) => {
  const routeData = router.resolve(path)
  window.open(routeData.href, '_blank')
}
Vue.prototype.$sendGAEvent = (title, content = {}) => {
  let communityName
  try {
    communityName = JSON.parse(localStorage.getItem('loginUserInfo')).CommunityName
  } catch (e) {
  }

  Vue.$gtag.event(title, {
    community_name: communityName,
    ...content
  })
}
global.apiAttendanceManagement = apiAttendanceManagement
global.apiBulletin = apiBulletin
global.apiBaAlert = apiBaAlert
global.apiBaAlertSource = apiBaAlertSource
global.apiBillservice = apiBillservice
global.apiBillserviceKGI = apiBillserviceKGI
global.apiCalendar = apiCalendar
global.apiUnitOwnerAssembly = apiUnitOwnerAssembly
global.apiMessage = apiMessage
global.apiSystem = apiSystem
global.apiGas = apiGas
global.apiGuest = apiGuest
global.apiVote = apiVote
global.apiIntercom = apiIntercom
global.apiManagement = apiManagement
global.apiAsset = apiAsset
global.apiHousehold = apiHousehold
// ! End 飯糰、沐謙討論後表示不要再增加進全域了，需要時再各自 import 即可 -------------------------------------------------

let logoutPage = ''
axios.interceptors.request.use(config => {
  return config
}, err => {
  return Promise.reject(err)
})
axios.interceptors.response.use(response => {
  return response
}, err => {
  console.log(err)
  console.log(err.response)
  // eslint-disable-next-line eqeqeq
  if ((err.response.config.url.indexOf(process.env.VUE_APP_BILL_URL) > -1 || err.response.config.url.indexOf('/billservice') > -1) && err && err.response && (err.response.status == 401 || err.response.status == 403)) {
    // eslint-disable-next-line eqeqeq
    if (logoutPage != router.history.current.name) {
      logoutPage = router.history.current.name
      Vue.prototype.$alert(`${err.response.data.ErrorMessage.Description}`, '警告', {
        confirmButtonText: '確定',
        type: 'warning',
        showClose: false,
        roundButton: true,
        closeOnClickModal: false
      }).then(() => {
        // eslint-disable-next-line eqeqeq
        if (err.response.status == 401) {
          router.push({ name: 'LoginMain' })
        // eslint-disable-next-line eqeqeq
        } else if (err.response.status == 403) {
          Vue.prototype.$toMainPage()
        }
      })
    } else {
      logoutPage = ''
    }
  }
  // 判斷公告
  // eslint-disable-next-line eqeqeq
  if ((err.response.config.url.indexOf(process.env.VUE_APP_MAPI_URL) > -1 || err.response.config.url.indexOf(process.env.VUE_APP_CORE_URL) > -1) && err && err.response && (err.response.status == 401 || err.response.status == 403) && err.response.data.ErrorMessage && router.history.current.name !== 'LoginMain') {
    // eslint-disable-next-line eqeqeq
    if (logoutPage != router.history.current.name) {
      logoutPage = router.history.current.name
      Vue.prototype.$alert(`${err.response.data.ErrorMessage.Description}`, '警告', {
        confirmButtonText: '確定',
        type: 'warning',
        showClose: false,
        roundButton: true,
        closeOnClickModal: false
      }).then(() => {
        // eslint-disable-next-line eqeqeq
        if (err.response.status == 401) {
          router.push({ name: 'LoginMain' })
        // eslint-disable-next-line eqeqeq
        } else if (err.response.status == 403) {
          Vue.prototype.$toMainPage()
        }
      })
    } else {
      logoutPage = ''
    }
  }
  // 判斷housekeeper.core (批次包裹)
  // eslint-disable-next-line eqeqeq
  if (err.response.config.url.indexOf(process.env.VUE_APP_CORE_URL) > -1 && err && err.response && (err.response.status == 401 || err.response.status == 403) && err.response.data.ErrorMessage && router.history.current.name !== 'LoginMain') {
    // eslint-disable-next-line eqeqeq
    if (logoutPage != router.history.current.name) {
      logoutPage = router.history.current.name
      Vue.prototype.$alert(`${err.response.data.ErrorMessage.Description}`, '警告', {
        confirmButtonText: '確定',
        type: 'warning',
        showClose: false,
        roundButton: true,
        closeOnClickModal: false
      }).then(() => {
        // eslint-disable-next-line eqeqeq
        if (err.response.status == 401) {
          router.push({ name: 'LoginMain' })
        // eslint-disable-next-line eqeqeq
        } else if (err.response.status == 403) {
          Vue.prototype.$toMainPage()
        }
      })
    } else {
      logoutPage = ''
    }
  }
  return Promise.reject(err)
})
// ----------------------------------------------------------------------------------------------------
Vue.config.productionTip = false
try {
  global.APPLICATION_VERSION = APPLICATION_VERSION
} catch (e) {
  console.log(e)
}

Sentry.init({
  Vue,
  enabled: process.env.NODE_ENV === 'production',
  dsn: 'https://6605039115a4f11c05903a336dbf016b@o4504591611002880.ingest.sentry.io/4506109549215744',
  release: `${process.env.VUE_APP_VERSION}.${process.env.VUE_APP_VERSION_DATE}`,
  environment: process.env.VUE_APP_ENV,
  maxBreadcrumbs: 50,
  integrations: [
    new Sentry.Integrations.Breadcrumbs({
      console: false // 如果是預設的true，開發時console裡無法定位到錯誤位址
    })
  ]
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
